/* eslint-disable no-labels */
import { getRoomTermsAndConditions } from '../../helpers/room-dynamic-data.js';

class MrTermsAndConditions extends HTMLElement {

	constructor() {
		super();

		this._stateHandler = ( e ) => {
			if ( !e || !e.detail || !e.detail.step_room ) {
				return;
			}

			const state = e.detail.step_room;

			if ( !state.rooms ) {
				return;
			}

			const link = this.querySelector( 'a' );
			if ( !link ) {
				return;
			}

			let room_id;
			let subroom_id;

			state.rooms.forEach( ( room ) => {
				if ( !room.selected ) {
					return;
				}

				room_id = room.room_id;

				if ( room.sub_rooms && room.sub_rooms.length ) {
					room.sub_rooms.forEach( ( sub_room ) => {
						if ( !sub_room.selected ) {
							return;
						}

						subroom_id = sub_room.subroom_id;
					} );
				}
			} );

			if ( !room_id ) {
				link.removeAttribute( 'href' );

				// If no room is selected but all terms and conditions are the same
				{
					const terms = new Set();

					TERMS_LOOP:
					for ( const room of state.rooms ) {
						if ( room.sub_rooms?.length ) {
							for ( const sub_room of room.sub_rooms ) {
								terms.add( getRoomTermsAndConditions( room.room_id, sub_room.subroom_id ) );

								if ( terms.size > 1 ) {
									break TERMS_LOOP;
								}
							}
						} else {
							terms.add( getRoomTermsAndConditions( room.room_id ) );

							if ( terms.size > 1 ) {
								break;
							}
						}
					}

					if ( terms.size === 1 ) {
						link.href = Array.from( terms )[0];
					}
				}

				return;
			}

			const termsAndConditions = getRoomTermsAndConditions( room_id, subroom_id );
			if ( termsAndConditions ) {
				link.href = termsAndConditions;
			} else {
				link.removeAttribute( 'href' );
			}
		};
	}

	// Life cycle
	connectedCallback() {
		this._addEventListeners();
	}

	disconnectedCallback() {
		this._removeEventListeners();
	}

	_addEventListeners() {
		window.addEventListener( 'rent-space:state-change', this._stateHandler );
	}

	_removeEventListeners() {
		window.removeEventListener( 'rent-space:state-change', this._stateHandler );
	}
}

customElements.define( 'mr-terms-and-conditions', MrTermsAndConditions );
